import ContactSection from '../component/ContactSection'
import AboutHero from '../component/AboutHero'
import TestimonialsSection from '../component/TestimonialsSection'
import ValuesSection from '../component/ValuesSection'
import StatsSection from '../component/StatsSection'
import LocationHighlightSection from '../component/LocationHighlightSection'
import TargetAudienceSection from '../component/TargetAudienceSection'
import WhyChooseUsNewSection from '../component/WhyChooseUsNewSection'
import AboutSectionInside from '../component/AboutSectionInside'

const Aboutus = () => {
  return (
    <>
    <AboutHero/>
    <AboutSectionInside />
    {/* <LocationHighlightSection/> */}
    <TargetAudienceSection/>
    <WhyChooseUsNewSection/>
    <StatsSection />
    <ValuesSection />
    <TestimonialsSection />
    </>
  )
}

export default Aboutus
